import React, { memo } from 'react'
import { transformTextVariables } from 'utils/text-transformation'
import * as Styled from './styled'
import { IUnlimitedBanner } from '../types'

const UnlimitedBanner: React.FC<Omit<IUnlimitedBanner, 'modelKeys'>> = ({
  text,
  highlightText,
  onClick
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClick()
  }

  return (
    <Styled.Wrapper onClick={handleClick}>
      <Styled.BannerText>
        {highlightText
          ? transformTextVariables(text, [
              { value: highlightText, Comp: Styled.Highlight }
            ])
          : text}
      </Styled.BannerText>
    </Styled.Wrapper>
  )
}

export default memo(UnlimitedBanner)
